import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/view/index'// 首页
import Service from '@/view/service'// 服务页面
import Query from '@/view/query' // 查询
import My from '@/view/my' // 我的
import Success from '@/view/success' // 成功获取开箱码
import Pictures from '@/view/pictures' // 取车还车拍照
import Complete from '@/view/complete' // 服务完成
import Login from '@/view/login' // 登录页面
import Analysis from '@/view/analysis' // 登录页面
import MySite from '@/view/mySite' // 登录页面
import Verification from '@/view/verification' // 登录页面
import PlaceAnOrder from '@/view/placeAnOrder' // 开单
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {path: '/',name: 'index',component: Index, meta: {title: '首页'}},
    {path: '/analysis', name: 'analysis', component: Analysis, meta: { title: '收入分析' }},
    {path: '/login',name: 'login',component: Login,meta: {title: '员工认证'}},
    {path: '/service',name: 'service',component: Service,meta: {title: '服务'}},
    {path: '/query',name: 'query',component: Query,meta: {title: '查询'}},
    {path: '/my',name: 'my',component: My,meta: {title: '我的'}},
    {path: '/success',name: 'success',component: Success,meta: {title: '获取钥匙码'}},
    {path: '/pictures',name: 'pictures',component: Pictures,meta: {title: '外检拍照'}},
    {path: '/complete',name: 'complete',component: Complete,meta: {title: '服务完成'}},
    {path: '/mySite',name: 'mySite',component: MySite,meta: {title: '站点切换'}},
    {path: '/verification',name: 'verification',component: Verification,meta: {title: '团购核销'}},
    {path: '/placeAnOrder',name: 'placeAnOrder',component: PlaceAnOrder,meta: {title: '开单'}},
  ],
  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js